<template>
  <div class="chartTooltip" v-html="this.toolTipVal">  
     
  </div>
</template>
<script>

  export default {
    name: "ChartTooltip",
    props:{
      toolTipVal: String
    },
    data() {
      return {
      }
    },
    }
</script>
<style lang="scss" scoped>
.chartTooltip{
  pointer-events: auto;
  border-radius: 5px;
  color:black;
  background-color:#F5F5F5;
  padding:7px;
}
</style>